// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/live-axios';
import { dispatch } from '../index';

// types
import { DefaultRootStateProps } from 'types';

// ----------------------------------------------------------------------

const initialState: DefaultRootStateProps['dynamicData'] = {
	error: null,
	dynamicData: [],
};

const slice = createSlice({
	name: 'dynamicData',
	initialState,
	reducers: {
		hasError(state, action) {
			state.error = action.payload;
		},

		getDynamicDataSuccess(state, action) {
			state.dynamicData = action.payload;
		},
	},
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export const dynamicDataApi = {
	getAll: () => async () => {
		try {
			const response = await axios.get('/notification/dynamicData');
			dispatch(slice.actions.getDynamicDataSuccess(response.data));
		} catch (error) {
			dispatch(slice.actions.hasError(error));
		}
	},
};
